import { css } from 'glamor'

import * as PropTypes from 'prop-types'
import * as React from 'react'

import { pageContainer, pageContainerContent } from './styles'

interface IPageContainerProps {
  children: React.ReactNode
  verticallyCentered?: boolean
  horizontallyCentered?: boolean
}

/**
 * <PageContainer>
 * A simple, re-usable page container for your page content
 *
 * @type React.Component
 *
 * @prop {Node} [children]
 *
 * @prop {Boolean} [verticallyCentered=false]
 *   - Whether or not to vertically center the page container's content
 *
 * @prop {Boolean} [horizontallyCentered=false]
 *   - Whether or not to horizontally center the page container's content
 *
 * @example

  <PageContainer verticallyCentered horizontallyCentered>
    My centered content
  </PageContainer>

*/
export function PageContainer({ children, verticallyCentered, horizontallyCentered }: IPageContainerProps) {
  return (
    <div {...css(pageContainer.base)}>
      <div
        {...css(
          pageContainerContent.base,
          verticallyCentered && pageContainerContent.verticallyCentered,
          horizontallyCentered && pageContainerContent.horizontallyCentered
        )}
      >
        {children}
      </div>
    </div>
  )
}

PageContainer.propTypes = {
  children: PropTypes.node,
  verticallyCentered: PropTypes.bool,
  horizontallyCentered: PropTypes.bool,
}
